import React from "react";
import EconoHeader from "./EconoHeader";
import "./style.css";

const EconoWorkout = () => {
  return (
    <div className="econo">
      <EconoHeader />
    </div>
  );
};

export default EconoWorkout;
